var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 3.501V2.313a.56.56 0 0 0-.562-.563.56.56 0 0 0-.563.563v2.625c0 .312.25.562.563.562h2.625a.561.561 0 1 0 0-1.125H2.89A4.874 4.874 0 0 1 11.875 7a4.874 4.874 0 0 1-7.563 4.067.563.563 0 0 0-.623.938A6 6 0 1 0 7 1a5.99 5.99 0 0 0-4.876 2.5m4.875.5a.56.56 0 0 0-.562.562V7c0 .15.058.293.164.399l1.687 1.687a.562.562 0 0 0 .795-.795L7.56 6.769V4.563A.56.56 0 0 0 6.998 4z"
  })));
};
export default SvgHistory;